/**
 * @fileoverview Agent definition for extract-styleguide-v2.
 *
 * This is a COMPOSITE agent that extracts a complete style guide from a text
 * sample by orchestrating three primitive agents:
 * 1. genre-detector-v2: Detects genres from the text
 * 2. style-analyzer-v2: Analyzes style to get slider values
 * 3. generate-custom-style-guide-v2: Generates the final style guide
 *
 * @category meta.style.analysis
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'extract-styleguide-v2',
  kind: 'composite',
  name: 'Extract Style Guide',
  description: 'Analyzes a text sample to detect genres and derive a complete style guide automatically.',
  category: 'style',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2024-10',
    lastUpdated: '2026-01',
    usedBy: [
      'StyleGuideDeriveDialog',
      'use-extract-styleguide.ts',
    ],
    // Composite agents specify which primitives they orchestrate
    composedOf: [
      'genre-detector-v2',
      'style-analyzer-v2',
      'generate-custom-style-guide-v2',
    ],
    // Per-step model configuration is managed via project-level stepOverrides
    // (configured in Settings > Orchestration)
    relatedAgents: ['genre-detector-v2', 'style-analyzer-v2', 'generate-custom-style-guide-v2'],
    taxonomyPath: 'meta.style.analysis',
  },
};
